import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const ImpersonationBanner: React.FC = () => {
  const { isImpersonating, impersonatedUser, endImpersonation } = useAuth();

  if (!isImpersonating || !impersonatedUser) {
    return null;
  }

  return (
    <div className="bg-yellow-500 dark:bg-yellow-600 border-b border-yellow-600 dark:border-yellow-700 px-4 py-2">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <AlertTriangle className="w-5 h-5 text-yellow-900 dark:text-yellow-100" />
          <div className="text-sm font-medium text-yellow-900 dark:text-yellow-100">
            <span className="font-bold">IMPERSONATION MODE:</span> You are currently logged in as{' '}
            <span className="font-semibold">
              {impersonatedUser.firstName} {impersonatedUser.lastName}
            </span>{' '}
            ({impersonatedUser.email})
          </div>
        </div>
        <button
          onClick={endImpersonation}
          className="flex items-center gap-2 px-3 py-1 bg-yellow-600 dark:bg-yellow-700 hover:bg-yellow-700 dark:hover:bg-yellow-800 text-yellow-900 dark:text-yellow-100 rounded-md text-sm font-medium transition-colors"
        >
          <X className="w-4 h-4" />
          Exit Impersonation
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;

